(function($) {

    $.fn.calendar = function(options) {
        // build main options before element iteration
        options = $.extend(true, {}, $.fn.calendar.defaults, options);

        return this.each(function() {
            var $this = $(this);
            // build element specific options
            $this.options = $.metadata ? $.extend(true, {}, options, $this.metadata()) : options;
            $this.options = $.fn.dataset ? $.extend(true, $this.options, $this.dataset()) : $this.options;

            var $calendar = $this;

            var $calendarContainer = $calendar.closest('.calendar-container');

            $calendarContainer.find('.toggle-multi-day-events').buttonset();

            var parameters = $calendar.metadata();

            var date = moment();

            if (parameters.month || parameters.month == 0) {
                date.month(parameters.month);
            }
            if (parameters.year) {
                date.year(parameters.year);
            }
            if (parameters.day) {
                date.date(parameters.day); //use date of month
            }

            enableFilterColouring();

            var isUS = $('html').attr('lang') == 'en-US';
            var minCalendarHeight = 250;
            var isActivity = $calendar.closest('#activity-calendar,#activity-timeline').size() > 0;
            var headerLeft = parameters.headerLeft;
            var headerCentre = parameters.headerCentre;
            var headerRight = parameters.headerRight;
            var defaultView = parameters.defaultView;
            var eventSources = [];
            //FPM-6075 unescape timelineConflicts url otherwise only the 1st param will be sent back to server.
            //see ReourcesPaths.getFullPath method.
            $.each(parameters.eventSources, function(i, v){
                if ((typeof v === "string") && v.indexOf('&amp;') > -1) {
                    eventSources.push($('<div/>').html(v).text());
                } else {
                    eventSources.push(v);
                }
            });
            $calendar.data('eventSources', eventSources);
            var resourceSource = parameters.resourceSource || null;
            var resourceGroupField = parameters.resourceGroupField || null;
            var resourceLabelText = parameters.resourceLabelText || null;
            var height = isActivity ? Math.max(minCalendarHeight, $(window).height() - $calendar.offset().top + 37) : 'auto';

            var now = moment().tz('UTC');
            if ($this.options.timezone != undefined) {
                //convert the current time to user's local time based on the time zone.
                var localTime = moment().tz($this.options.timezone);
                now.hours(localTime.hour());
                now.minutes(localTime.minute());
            }

            //noinspection JSUnusedLocalSymbols
            $calendar.fullCalendar({
                schedulerLicenseKey: '0457248865-fcs-1448975878',
                theme: true,
                defaultView: defaultView,
                header: {
                    left: headerLeft,
                    center: headerCentre,
                    right: headerRight
                },
                height: height,
                weekends: true,
                editable: true,
                defaultDate: date,
                startParam: 'startDate',
                endParam: 'endDate',
                eventSources: eventSources,
                resources: resourceSource,
                weekNumbers: true,
                nowIndicator: true,
                now:now.toISOString(),
                timeFormat: 'H:mm',
                axisFormat: 'H:mm',
                timezone: 'UTC',
                eventLimit: 6,
                eventLimitText: translate('more'),
                dayPopoverFormat: 'LL',
                fixedWeekCount: false,
                nextDayThreshold: "00:00:00",
                resourceGroupField: resourceGroupField,
                resourceAreaWidth: "150px",
                resourceLabelText: resourceLabelText,
                views: {
                    month: {
                        titleFormat: 'MMMM YYYY',
                        columnFormat: 'ddd'
                    },
                    week: {
                        titleFormat: "LL",
                        columnFormat: isUS ? 'ddd, MMM D' : 'ddd, D MMM'
                    },
                    day: {
                        titleFormat: 'LL',
                        columnFormat: isUS ? 'dddd, MMMM D' : 'dddd, D MMMM'
                    },
                    timelineDay: {
                        titleFormat: 'LL',
                        slotLabelFormat: [
                            isUS ? 'ddd, MMM D' : 'ddd, D MMM', // Day
                            'H:mm' // Time
                        ]
                    },
                    timelineWeek: {
                        titleFormat: "LL",
                        slotLabelFormat: [
                            '[Wk]W', // Week
                            isUS ? 'ddd, MMM D' : 'ddd, D MMM', // Day
                            'H:mm' // Time
                        ],
                        slotDuration: {hours: 1},
                        slotLabelInterval: {hours: 2}
                    },
                    timelineMonth: {
                        titleFormat: 'MMMM YYYY',
                        slotLabelFormat: [
                            '[Wk]W', // Week
                            'dd D' // Day
                        ]
                    },
                    timelineYear: {
                        slotDuration: {months: 1}
                    },
                    conflictsDay: {
                        type: 'timeline',
                        titleFormat: 'LL',
                        slotLabelFormat: [
                            isUS ? 'ddd, MMM D' : 'ddd, D MMM', // Day
                            'H:mm' // Time
                        ],
                        duration: { days: 1 },
                        slotDuration: {hours: 1}
                    },
                    conflictsWeek: {
                        type: 'timeline',
                        titleFormat: "LL",
                        slotLabelFormat: [
                            '[Wk]W', // Week
                            isUS ? 'ddd, MMM D' : 'ddd, D MMM' // Day
                        ],
                        duration: { weeks: 1 },
                        slotDuration: {days: 1}
                    },
                    conflictsMonth: {
                        type: 'timeline',
                        titleFormat: 'MMMM YYYY',
                        slotLabelFormat: [
                            '[Wk]W', // Week
                            'dd D' // Day
                        ],
                        duration: { months: 1 }
                    }
                },

                /** Load the url using ajax and pop up a dialog */
                eventClick: function(event, jsEvent, view)
                {
                    if (event.viewUrl) {
                        $('<a />').attr('href', event.viewUrl).msxidialog({
                            resetOnClose: true,
                            captureDialogLinks: event.isEvent
                        }).click();
                    }
                    return false;
                },

                viewRender: function(view)
                {
                    // Force to re-render all events since their appearance depends from view
                    $calendar.fullCalendar( 'rerenderEvents' );

                    // Remove header styling from divider
                    $calendar.find('.fc-divider').removeClass('ui-widget-header').addClass('ui-state-default');

                    updateDatePicker();

                    if(view.intervalUnit == 'month' || (view.options.slotDuration && moment.duration(view.options.slotDuration).days() == 1) || view.name.indexOf('agenda') > -1) {
                        // in month or timelineMonth views or for all-day events in agenda* views
                        // the granularity is 1 day so we show the fc-event according to the selected multi-day mode(split or join)
                        // so enable toggle buttons
                        $calendarContainer.find('.toggle-multi-day-events').buttonset('option', 'disabled', false);
                    }
                    else {
                        // in year view we show the join events because the granularity is greater than 1 day
                        // in week, day, timelineWeek and timelineDay view we show the split events because the granularity is less than 1 day
                        // so disable toggle buttons
                        $calendarContainer.find('.toggle-multi-day-events').buttonset('option', 'disabled', true);
                    }

                },

                eventRender : function(event, element, view)
                {
                    var $element = $(element);

                    // don't show the event if it is configured to not be displayed in this view
                    var showEvent = true;
                    if(event.multiDayMode) {
                        // multi-day events are added to the model twice,
                        // once with an fc-event per event slot (split)
                        // and once with an fc-event per set of contiguous event slots (join)
                        if(view.intervalUnit == 'month' || (view.options.slotDuration && moment.duration(view.options.slotDuration).days() == 1) || (view.name.indexOf('agenda') > -1 && event.allDay)) {
                            // in month or timelineMonth views or for all-day events in agenda* views
                            // the granularity is 1 day so we show the fc-event according to the selected multi-day mode(split or join)
                            showEvent = event.multiDayMode == $calendar.data('multi-day-mode');
                        }
                        else if((view.options.slotDuration && moment.duration(view.options.slotDuration).asDays() > 1.0)) {
                            // in year view we show the join events because the granularity is greater than 1 day
                            showEvent = event.multiDayMode == 'join';
                        }
                        else {
                            // in week, day, timelineWeek and timelineDay view we show the split events because the granularity is less than 1 day
                            showEvent = event.multiDayMode == 'split';
                        }
                    }
                    if(event.rendering == 'background') {
                        // background events are not displayed in year mode and are only displayed in month mode if they are all-day
                        showEvent = view.intervalUnit != 'year' && (view.intervalUnit != 'month' || event.allDay);
                    }
                    if(!showEvent) {
                        return false;
                    }


                    // Retrieve eventTitle element so can dynamically populate using event fields
                    var $eventTitle = $element.find(".fc-title");
                    if($eventTitle.size()>0) {
                        var activityHtml = ' <span class="icon dealer-program-event-icon" data-icon="' + event.cssClass + '" data-icon-overlay="' + event.cssClass + '" title = "' + event.eventType + '"></span>&nbsp;';
                        if (event.redAlert) {
                            activityHtml += '<span class="indicator-icon icon ui-state-negative" data-icon="ui-icon-bullet" title="' + event.redAlert + '"></span>';
                        }
                        if(event.name) {
                            activityHtml += '<span class="activity-name" >'+event.name+'</span>';
                        }
                        if (event.targetCode) {
                            activityHtml += '<span class="activity-target" >' + event.targetCode + '</span>';
                        }

                        if (event.dealershipName) {
                            if (event.targetCode) {
                                activityHtml += ' - ';
                            }
                            var dealership = event.dealershipName;
                            if (event.dealershipCode) {
                                dealership += ' ' + event.dealershipCode;
                            }
                            activityHtml += '<span class="activity-dealership" >' + dealership + ' </span>';
                        }

                        if (event.targetName) {
                            if (event.targetCode || event.dealershipName) {
                                activityHtml += ' - ';
                            }
                            activityHtml += '<span class="activity-target" >' + event.targetName + ' </span>';
                        }

                        if (event.companyVisitedCssClass) {
                            var companyVisited = event.companyVisitedName;
                            if (event.companyVisitedCode) {
                                companyVisited += ' ' + event.companyVisitedCode;
                            }

                            activityHtml += '<span class="icon company-visited-icon" data-icon="' + event.companyVisitedCssClass + '" data-icon-overlay="' + event.companyVisitedCssClass + '"></span>&nbsp;<span class="company-visited-name">' + companyVisited + '</span>';
                        }
                        $eventTitle.html(activityHtml);
                        var tooltip = '';
                        if(event.startTime) {
                            tooltip += event.startTime + ' - ';
                        }
                        if(event.endTime) {
                            tooltip += event.endTime + ' - ';
                        }
                        if(event.isHistory || event.isEvent) {
                            tooltip += event.eventType + ' ';
                        }
                        if(!event.hasHiddenDetails) {
                            tooltip += $eventTitle.html();
                        }
                        $element.closest("a").attr('title', tooltip).tooltip({'content': tooltip,
                            open: function( event, ui ) {
                                ui.tooltip.find('.icon').msxiicon();
                            }});
                        $element.find('.icon').msxiicon();
                    }
                },

                resourceRender: function(resource, $cells) {
                    // add tooltip onto the resource labels
                    $cells.each(function(){
                        $(this).find('.fc-cell-text').attr('title', resource.title);
                    });

                    // Remove header styling from divider and ensure has grey background
                    $calendar.find('.fc-divider').removeClass('ui-widget-header').addClass('ui-state-default');
                },

                eventDragStart: function( event, jsEvent, ui, view ) {
                    if (event.resourceId) {
                        event.originalResourceId = event.resourceId;
                    }
                },

                eventDrop: function(event, delta, revertFunc, jsEvent, ui, view)
                {
                    if (!event.resourceId || event.resourceId == event.originalResourceId) {
                        if($calendar.options.eventReschedule) {
                            $calendar.options.eventReschedule.call(this, event, delta, revertFunc, jsEvent, ui, view);
                        }
                        else {
                            reschedule(event, delta, revertFunc, jsEvent, ui, view);
                        }
                    } else {
                        // don't allow drop on different resource in timeline view
                        revertFunc();
                    }
                },

                eventResize: function(event, delta, revertFunc, jsEvent, ui, view)
                {
                    var start = moment(event.start);
                    var end = moment(event.end);
                    if(start.date() == end.date()) {
                        if($calendar.options.eventReschedule) {
                            $calendar.options.eventReschedule.call(this, event, delta, revertFunc, jsEvent, ui, view);
                        }
                        else {
                            reschedule(event, delta, revertFunc, jsEvent, ui, view);
                        }
                    }
                    else {
                        // cannot resize to a different day
                        revertFunc();
                    }

                },

                dayClick: function(date, jsEvent, view, resourceObj)
                {
                    var $addButton = $calendarContainer.find('#create-event-button');
                    if ($addButton.size() > 0)
                    {
                        var isMonthView = view.name == "month" || view.name == "timelineMonth";
                        var startDate = date;
                        var endDate;
                        if (isMonthView) {
                            startDate = date.clone();
                            endDate = date.clone();
                        } else {
                            //if start hour is after 23, make the end hour to be 23:59
                            //otherwise 1 hour after.
                            var hour = date.hour();
                            if (hour < 23) {
                                endDate = date.clone().hour(hour+1);
                            } else {
                                endDate = date.clone().hour(23).minute(55);
                            }
                        }

                        var formattedStartDate = startDate.format('YYYY-MM-DD HH:mm');
                        var formattedEndDate = endDate.format('YYYY-MM-DD HH:mm');
                        var param = "scheduledStartDate=" + formattedStartDate + "&scheduledEndDate=" + formattedEndDate;
                        if(resourceObj && resourceObj.id && parameters.resourceField) {

                            param += "&" + parameters.resourceField + "=" + resourceObj.id;
                        }
                        var metadata = $addButton.metadata();
                        if(metadata.fromCalendarScreen)
                        {
                            param += "&fromCalendarScreen=true";
                        }
                        else if(metadata.fromTimelineScreen)
                        {
                            param += "&fromTimelineScreen=true";
                        }
                        if (isMonthView) {
                            //Click from month view so default as all day event.
                            param += "&allDay=true";
                        }
                        $('<a />').attr('href', '/fpm/activity/createEvent?' + param).msxidialog({resetOnClose:true}).click();
                    }
                },

                loading: function(isLoading, view){
                    if($calendar.options.loading) {
                        $calendar.options.loading.call(this, isLoading, view);
                    }
                    if(isLoading) {
                        showLoadingMessage();
                    }
                    else
                    {
                        hideLoadingMessage();
                        $calendar.find('.event-selected').effect('pulsate', 2000);
                    }
                },
                eventAfterAllRender: function(view) {
                    if($calendar.options.eventAfterAllRender) {
                        $calendar.options.eventAfterAllRender.call(this, view);
                    }
                }
            });

            if (isActivity) {
                $(window).resize(function () {
                    /* keep the calendar size in sync with the window size */
                    $calendar.fullCalendar('option', 'height', Math.max(minCalendarHeight, $(window).height() - $calendar.offset().top));
                });
            }


            var $datepicker = $calendarContainer.find('.fc-datepicker');
            //noinspection JSUnusedLocalSymbols
            $datepicker.msxidatepicker(
                {
                    datepicker: {
                        changeMonth: true,
                        changeYear: true,
                        onSelect: function(dateText, inst)
                        {
                            // get date object from datepicker rather than dateText as latter is in dd/mm/yy format which
                            // is not suitable for gotoDate function
                            var d = $datepicker.datepicker("getDate");
                            // parse using UTC to correctly handle DST dates
                            $calendar.fullCalendar('gotoDate',moment.utc([d.getFullYear(), d.getMonth(), d.getDate()]));
                        }
                    }
                });

            $datepicker.datepicker("setDate", date.toDate());

            var $controlPanelLeft = $calendarContainer.find('.control-panel-left');
            $controlPanelLeft.find('.ui-button').prop('disabled', true).addClass('ui-state-disabled');
            $controlPanelLeft.appendTo($calendarContainer.find('.fc-toolbar .fc-left'));

            var $controlPanelRight = $calendarContainer.find('.control-panel-right');
            $controlPanelRight.find('.ui-button').prop('disabled', true).addClass('ui-state-disabled');
            $controlPanelRight.prependTo($calendarContainer.find('.fc-toolbar .fc-right'));

            $calendarContainer.find('.refresh-calendar-button,.refresh-timeline-button').click(function(){
                $calendar.fullCalendar('refetchEvents');
                return false;
            });

            var $calendarForm = $calendarContainer.find('.calendar-form');

            var resourceGroup = $('#idResourceGroup').val();
            $calendarForm.on('change', '#idResourceGroup', function(){
                var newResourceGroup = $('#idResourceGroup').val();
                if (newResourceGroup !== resourceGroup) {
                    $calendarForm.data('resourceGroupChanged', true);
                    resourceGroup = newResourceGroup;
                }
            });

            $calendarForm.submit(function(e){
                if (!$calendarForm.data('resourceGroupChanged')) {
                    showLoadingMessage();
                    //noinspection JSUnusedLocalSymbols
                    $.ajax({
                        type: $calendarForm.attr('method'),
                        url: $calendarForm.attr('action'),
                        data: $calendarForm.formToArray(),
                        success: function (data) {
                            enableFilterColouring();
                            $calendar.fullCalendar('refetchEvents');
                            $calendar.fullCalendar('refetchResources');
                            $calendarForm.find('input.ui-button:submit,button.ui-button:submit').button('enable');
                            $calendarForm.trigger('submitted');

                            if($calendarForm.data('duplicateSubmissionBlocker')) {
                                // if a duplicate submission blocker has been added to form then remove it, otherwise it will not be possible to submit if resourceGroupChanged==false
                                $calendarForm.off( 'submit', $calendarForm.data('duplicateSubmissionBlocker'));
                                $calendarForm.removeData('duplicateSubmissionBlocker');
                            }
                        }
                    });
                    return false;
                }
            });

            /* clicking on a week number switches to week view displaying that week */
            $calendar.on('click', 'td.fc-week-number span', function(){
                $calendar.fullCalendar( 'changeView', "agendaWeek");
                var moment = $calendar.fullCalendar( 'getDate');
                moment.week($(this).text());
                $calendar.fullCalendar( 'gotoDate', moment);
            });

            setMultiDayMode('join');

            var $joinButton = $calendarContainer.find('.join-multi-day-events');
            var $splitButton = $calendarContainer.find('.split-multi-day-events');
            $joinButton.addClass('toggle-state-active');
            $joinButton.click(function(){
                setMultiDayMode('join');
            });
            $splitButton.click(function(){
                setMultiDayMode('split');
            });

            function setMultiDayMode(mode) {
                var oldMode = $calendar.data('multi-day-mode');
                if (oldMode != mode) {
                    $calendar.data('multi-day-mode', mode);
                    $calendar.fullCalendar('rerenderEvents');
                    var $joinButton = $calendarContainer.find('.join-multi-day-events');
                    var $splitButton = $calendarContainer.find('.split-multi-day-events');
                    if(mode == 'join') {

                        $joinButton.addClass('toggle-state-active');
                        $splitButton.removeClass('toggle-state-active');
                    }
                    else {
                        $splitButton.addClass('toggle-state-active');
                        $joinButton.removeClass('toggle-state-active');
                    }
                }
            }

            function updateDatePicker()
            {
                var d = $calendar.fullCalendar('getDate').toDate();
                $calendar.find('.fc-datepicker').datepicker("setDate", d);
            }

            //noinspection JSUnusedLocalSymbols
            function reschedule(event, delta, revertFunc, jsEvent, ui, view) {
                var start = moment(event.start);

                var isMonthView = view.name == "month" || view.name == "timelineMonth";
                var startDate = start.clone();
                var endDate;
                if (event.end !== null) {
                    endDate = moment(event.end);
                } else {
                    if (isMonthView) {
                        endDate = start.clone().hour(1);
                    } else {
                        //if start hour is after 23, make the end hour to be 23:59
                        //otherwise 1 hour after.
                        var hour = start.hour();
                        if (hour < 22) {
                            endDate = start.clone().hour(hour + 2);
                        } else {
                            endDate = start.clone().hour(23).minute(55);
                        }
                    }
                }

                showLoadingMessage();
                $calendar.data('rescheduling', true);
                //noinspection JSUnusedLocalSymbols
                $.ajax({
                    type: 'POST', /* Don't use "put", use hidden variable ('_method') workaround otherwise it fails to post the data!*/
                    url: event.rescheduleUrl,
                    traditional: true,
                    data: ({
                        allDay: event.allDay,
                        idEventSlot: event.id, // need to tell server which idEventSlot is changing otherwise server don't know which event slot is being moved.
                        idContiguousEventSlots: event.idContiguousEventSlots,
                        scheduledStartDate: startDate.format('YYYY-MM-DD HH:mm'),
                        scheduledEndDate: endDate.format('YYYY-MM-DD HH:mm'),
                        _method: 'PUT'
                    }),
                    dataType: 'html',
                    success: function (data) {
                        var $data = $(data);
                        var $reschedule = $data.find('.event-reschedule');
                        if ($reschedule !== undefined && $reschedule.size() > 0) {
                            //No conflicting, refresh the underlying calendar to sync the new start/end time.
                            $calendar.fullCalendar('refetchEvents');
                        } else {
                            var $noPermissionDiv = $data.find('.event-reschedule-no-permission');
                            var $dialog;
                            if ($noPermissionDiv.size() > 0) {
                                //User does not have permission to drag/drop event. Popup a dialog
                                $dialog = $('<div></div>');
                                $dialog.builddialog({
                                    title: 'Error',
                                    autoOpen: false
                                });
                                $dialog.builddialog('message', {text: $noPermissionDiv.data('error'), translateText: true});
                                $dialog.builddialog('button', {
                                    text: 'OK', translateText: true, click: function () {
                                        $dialog.dialog('close');
                                    }
                                });
                                $dialog.msxiinit();
                                $dialog.builddialog('show');
                                revertFunc();
                            } else {
                                var $form = $data.find('form');
                                if ($form.size() > 0) {
                                    //Events conflicting
                                    //Populate the dialog for user to edit the event.
                                    $dialog = $('<div></div>');
                                    $dialog.attr('class', 'dialog-link');
                                    $dialog.dialog($.extend({
                                        autoOpen: false
                                    }, $.fn.msxidialog.defaults.dialogOptions));

                                    var eOpts = $.extend({}, $.fn.msxidialog.defaults,
                                        {
                                            captureDialogLinks: true,
                                            resetOnClose:true, //destroy the form when disposing the conflict dialog.
                                            locationResponseToDialog: true, // contact reschedule/plan will return a redirect request.
                                            initAfterReset:false, // contact reschedule/plan cancel button should dispose the dialog and no need to init dialog again.
                                            onDialogLoadPost: function ($dialog) {
                                                $dialog.off("dialogclose").on("dialogclose", function () {
                                                    revertFunc();
                                                    $dialog.dialog("close");
                                                });
                                            }
                                        });

                                    $dialog.data('eOpts',eOpts);
                                    $.fn.msxidialog.customFillDialog($dialog, data, eOpts);

                                    $dialog.dialog('open');
                                }
                            }
                            hideLoadingMessage();
                        }
                    },
                    error: function (xmlLHttpRequest, errorText, errorThrown) {

                        handleAjaxError(xmlLHttpRequest, errorText);
                        hideLoadingMessage();
                        revertFunc();
                    }
                });
            }

            //noinspection JSUnusedLocalSymbols
            function showSuccessMessage(message, hideAfterTimeout)
            {
                $calendar.addClass('complete');
                if(hideAfterTimeout) {
                    setTimeout(function() {
                        $calendar.removeClass('complete');
                    }, 1000);

                }
            }
            var $spinnerOverlay, $spinner, spinner, $disabledButtons;
            function showLoadingMessage()
            {
                if (!$calendar.data('loading')) {
                    $calendar.data('loading', true);
                    var $calendarView = $calendar.find('.fc-view');
                    $spinnerOverlay = $('<div class="loading-spinner-overlay" />').appendTo($calendarView);
                    $spinner = $('<div class="loading-spinner"/>').appendTo($calendarView);
                    spinner = Spinners.create($spinner, $.fn.msxitabs.defaults.spinner).play();

                    $calendar.find('.fc-toolbar').find('.ui-button.ui-widget').not('label').button("disable");
                    $disabledButtons = $calendar.find('.fc-toolbar').find('.ui-button').not('label').not('.ui-widget').not('[disabled]');
                    $disabledButtons.prop("disabled", true).addClass('ui-state-disabled');
                    $calendar.find('.fc-toolbar').find('.fc-datepicker').prop('disabled', true);
                }
            }
            function hideLoadingMessage()
            {
                if ($calendar.data('loading')) {
                    spinner.remove();
                    $spinner.remove();
                    $spinnerOverlay.remove();

                    $calendar.find('.fc-toolbar').find('.fc-datepicker').prop('disabled', false);
                    $calendar.find('.fc-toolbar').find('.ui-button.ui-widget').not('label').button("enable");
                    $disabledButtons.prop("disabled", false).removeClass('ui-state-disabled');
                    $calendar.data('loading', false);
                }
            }

            function enableFilterColouring()
            {
                var $keys = $calendarContainer.find('.filter-colour');
                $keys.removeClass('filter-colour');
                // Remove additional width from previous filter for space no longer taken by coloured box
                $keys.each(function(){
                    if ($(this).attr('id')) {
                        var $dropdownList = $('#' + $(this).attr('id').substr(7));
                        $dropdownList.each(function () {
                            increaseDropDownWidth($dropdownList, -15);
                        });
                    }
                });
                var $colourScheme = $calendarContainer.find('#idColourScheme');
                if ($colourScheme.size() > 0) {
                    var toBeColouredId = $colourScheme.val();
                    var colourSchemeMap = $colourScheme.metadata();
                    if (colourSchemeMap.hasOwnProperty(toBeColouredId)) {
                        var idCheckboxes = colourSchemeMap[toBeColouredId];
                        $keys = $(idCheckboxes);
                        $keys.addClass('filter-colour');
                        // Add additional width to filter for space taken by coloured box
                        $keys.each(function () {
                            if ($(this).attr('id')) {
                                var $dropdownList = $('#' + $(this).attr('id').substr(7));
                                $dropdownList.each(function () {
                                    increaseDropDownWidth($dropdownList, 15);
                                });
                            }
                        });
                    }
                }
            }

            function increaseDropDownWidth($dropdownList, amount) {
                if($dropdownList.is('.jqx-widget.dropdownlist')) {
                    var dropDownWidth = $dropdownList.jqxDropDownList('dropDownWidth');
                    if (dropDownWidth != 'auto') {
                        $dropdownList.jqxDropDownList({dropDownWidth: dropDownWidth + amount});
                    } else {
                        $dropdownList.jqxDropDownList({dropDownWidth: $dropdownList.jqxDropDownList('width') + amount});
                    }
                }
            }

        });
    };
    //
    // plugin defaults
    //
    $.fn.calendar.defaults = {
    };

})(jQuery);